// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-csv.downloading{font-size:var(--font-size-xxs)}`, "",{"version":3,"sources":["webpack://./src/components/common/download-csv/DownloadCSV.scss"],"names":[],"mappings":"AACC,0BACC,8BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
